import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAlertStore = defineStore('alert', () => {
  const alerts = ref([])
  const dialogs = ref([])

  let nextId = 0

  function show(message, { color = 'success', timeout = 5000 } = {}) {
    const id = nextId++
    const alert = {
      id,
      message,
      color,
      timeout,
      show: true,
      timeoutId: null,
      countdown: Math.round(timeout / 1000)
    }

    // Start countdown
    if (timeout > 0) {
      alert.timeoutId = setTimeout(() => {
        dismiss(id)
      }, timeout)

      // Update countdown every second
      const countdownInterval = setInterval(() => {
        const alertIndex = alerts.value.findIndex(a => a.id === id)
        if (alertIndex === -1) {
          clearInterval(countdownInterval)
          return
        }
        alerts.value[alertIndex].countdown--
      }, 1000)
    }

    alerts.value.push(alert)
    return id
  }

  function dismiss(id) {
    const index = alerts.value.findIndex(alert => alert.id === id)
    if (index !== -1) {
      const alert = alerts.value[index]
      if (alert.timeoutId) {
        clearTimeout(alert.timeoutId)
      }
      alerts.value.splice(index, 1)
    }
  }

  async function showDialog(title, description, options = {}) {
    console.log('Entered showDialog');
    const {
      buttons = [
        { text: 'OK', value: 'ok', color: 'primary' },
        { text: 'Cancel', value: 'cancel', color: 'error' }
      ]
    } = options

    // Validate max 3 buttons
    if (buttons.length > 3) {
      throw new Error('Maximum of 3 buttons allowed')
    }

    console.log('title: ' + title);

    const id = nextId++
    const dialog = {
      id,
      title,
      description,
      buttons,
      show: true,
      result: null
    }

    return new Promise((resolve) => {
      dialog.handleClick = (value) => {
        console.log('dialog.handleClick: ' + value);
        dialog.show = false
        dialog.result = value
        const index = dialogs.value.findIndex(d => d.id === id)
        if (index !== -1) {
          dialogs.value.splice(index, 1)
        }
        resolve(value)
      }

      dialogs.value.push(dialog)
    })
  }
  return {
    alerts,
    dialogs,
    show,
    dismiss,
    showDialog
  }
})
